module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.2b93e8e9.ttf";